// @flow

import type {ApplicationRedux} from 'redux/ApplicationRedux';
import type {PutState} from 'redux/v1/paymentTravel/sepa/put/PutState';
import type {SepaValidationState} from 'redux/v1/paymentTravel/sepa/validation/SepaValidationState';

import {sepaState} from 'redux/v1/paymentTravel/PaymentTravelState';

export type SepaState = {
  putData: PutState,
  validationData: SepaValidationState,
};

export const putState = (state: ApplicationRedux): PutState =>
  sepaState(state).putData;

export const validationState = (state: ApplicationRedux): SepaValidationState =>
  sepaState(state).validationData;
